// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__Im6CR","footer":"ModalError_footer__2g80n"};